import { render } from "./Example2.vue?vue&type=template&id=556dc4a8"
import script from "./Example2.vue?vue&type=script&lang=ts"
export * from "./Example2.vue?vue&type=script&lang=ts"
script.render = render

export default script